import { render } from "./FormRepairingLocation.vue?vue&type=template&id=132a594c"
import script from "./FormRepairingLocation.vue?vue&type=script&lang=js"
export * from "./FormRepairingLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__